import { detectPlatform, PLATFORM } from '@app/helpers/platform';

const ZENDESK_SNIPPET_ID = 'ze-snippet';
export const RESET_ZENDESK_WIDGET_TIMEOUT_MS = 1000;

export function loadZendeskWidget(): void {
  try {
    if (!process.env.ENABLE_THIRD_PARTY_SCRIPTS) return;
    const widgetKey = process.env.ZENDESK_WIDGET_KEY;
    if (!widgetKey) return;
    if (detectPlatform() !== PLATFORM.WEB) return;
    if (document.getElementById(ZENDESK_SNIPPET_ID)) return;

    const script = document.createElement('script');
    script.id = ZENDESK_SNIPPET_ID;
    script.async = true;
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${encodeURIComponent(widgetKey)}`;
    document.head.appendChild(script);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to load Zendesk widget', err);
  }
}

export function resetZendeskWidget(): Promise<void> {
  return new Promise((resolve) => {
    if (typeof window.zE !== 'function') {
      resolve();
      return;
    }

    const timeoutId = setTimeout(resolve, RESET_ZENDESK_WIDGET_TIMEOUT_MS);
    const finish = () => {
      clearTimeout(timeoutId);
      resolve();
    };

    try {
      window.zE('messenger', 'resetWidget', finish);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to reset Zendesk widget', err);
      finish();
    }
  });
}
